import {action, autorun, reaction} from 'mobx';
import {VIEWS} from '../model/const';
import queryString from 'query-string';
import pathToRegexp from 'path-to-regexp';

export class Navigation {
  constructor(scene, history, vMaster, vPersonalData, sessionStorage) {
    this.vMaster = vMaster;
    this.scene = scene;
    this.history = history;
    this.vPersonalData = vPersonalData;
    this.sessionStorage = sessionStorage;
  }

  @action.bound goSearch() {
    this.history.push(VIEWS.search);
  }

  @action.bound startBookingWizard() {
    this.vPersonalData.hasBeenSubmitted = false;
    window.sessionStorage.removeItem('bwTrxId');

    window.sessionStorage.setItem('bwStartDate', window.sessionStorage.getItem('searchStartDate'));
    window.sessionStorage.setItem('bwEndDate', window.sessionStorage.getItem('searchEndDate'));
    window.sessionStorage.setItem('canInitTxn', 'true');
    
    this.history.push(VIEWS.bwOfferDetails); 
  }  

  @action.bound goHome() {
    window.sessionStorage.removeItem('bwTrxId');
    this.history.push(VIEWS.home);
  }

  @action.bound goObjectDetails() {
    window.sessionStorage.removeItem('bwTrxId');
    this.history.push(VIEWS.objectDetails);
  }

  @action.bound goBWOfferDetails() {
    this.history.push(VIEWS.bwOfferDetails);
  }

  @action.bound goBWServices() {
    this.history.push(VIEWS.bwServices);
  }

  @action.bound goBWAccessories() {
    this.history.push(VIEWS.bwAccessories);
  }

  @action.bound goBWPersonalData() {
    this.history.push(VIEWS.bwPersonalData);
  }

  @action.bound goBWReview() {
    this.history.push(VIEWS.bwReview);
  }

  @action.bound goBWPayment() {
    this.history.push(VIEWS.bwPayment);
  }

  @action.bound goBWFinished() {
    this.history.push(VIEWS.bwFinished);
  }

  @action.bound goUserProfile() {
    this.history.push(VIEWS.userProfile);
  } 

  @action.bound goRegistration() {
    this.history.push(VIEWS.userRegistration);
  }

  @action.bound goRecentBookings() {
    this.history.push(VIEWS.recentBookings);
  }

  @action.bound goRecentBookingDetail(trxId) {
    this.history.push(pathToRegexp.compile(VIEWS.recentBookingDetail)({trxId}));
  }

  @action.bound goUserRegistration1() {
    this.history.push(pathToRegexp.compile(VIEWS.userRegistration)({step: 1}));
  }

  @action.bound goUserRegistration2() {
    this.history.push(pathToRegexp.compile(VIEWS.userRegistration)({step: 2}));
  }
  
  @action.bound goUserRegistration3({token, userId}) {
    this.history.push({
      pathname: pathToRegexp.compile(VIEWS.userRegistration)({step: 3}), 
      search: queryString.stringify({token, userId}),
    });
  }   

  @action.bound goUserRegistration4({message}) {
    this.history.push({
      pathname: pathToRegexp.compile(VIEWS.userRegistration)({step: 4}), 
      search: queryString.stringify({message}),
    });
  }

  @action.bound goPasswordRecovery1() {
    this.history.replace({
      pathname: pathToRegexp.compile(VIEWS.forgottenPassword)({step: 1}), 
    });
  }

  @action.bound goPasswordRecovery2(email) {
    this.history.replace({
      pathname: pathToRegexp.compile(VIEWS.forgottenPassword)({step: 2}), 
      search: queryString.stringify({email, step: 2}),
    });    
  }  

  @action.bound goPasswordRecovery3({userName, token}) {
    this.history.replace({
      pathname: pathToRegexp.compile(VIEWS.forgottenPassword)({step: 3}), 
      search: queryString.stringify({userName, token}),
    });       
  }

  @action.bound goPasswordRecovery4() {
    this.history.replace({
      pathname: pathToRegexp.compile(VIEWS.forgottenPassword)({step: 4}), 
    });
  }
   
  hrefObjectDetails(objectId) {
    return `#/objectDetails?objId=${objectId}`;
  }

  thumbnailUrl(firstImageId) {
    return `/lessors/DBImg.ashx?id=${firstImageId}`
  }
}


// WEBPACK FOOTER //
// ./src/model/Navigation.js